// extracted by mini-css-extract-plugin
export default {"card":"FolderCard_card__eODr6","logo":"FolderCard_logo__2E4rt","header":"FolderCard_header__qBcez","withImage":"FolderCard_withImage__UonEl","noImage":"FolderCard_noImage__d6LlW"};